module.exports = __webpack_public_path__ + "img/gallery-image-0.eeff19ff.png";